export default [
    { lat: 48.259432, lng: 16.368001 },
    { lat: 48.211212, lng: 16.288738 },
    { lat: 48.237967, lng: 16.243823 },
    { lat: 48.239023, lng: 16.258618 },
    { lat: 48.284052, lng: 16.345808 },
]
